import client from '@/services/client.js'

const endpoint = 'product'

const allProducts = () => {
  return client.get(`${endpoint}`)
}

const randomProducts = () => {
  return client.get(`${endpoint}/random`)
}

const specificProduct = id => {
  return client.get(`${endpoint}/${id}`)
}

const createProduct = payload => {
  return client.post(endpoint, payload)
}

const deleteProduct = id => {
  return client.delete(endpoint, id)
}

const updateProduct = payload => {
  return client.put(endpoint, payload)
}

const createOption = payload => {
  return client.post(`${endpoint}/options`, payload)
}

const deleteOption = id => {
  return client.delete(`${endpoint}/options`, id)
}

const updateOption = payload => {
  return client.put(`${endpoint}/options`, payload)
}

export {
  allProducts,
  randomProducts,
  specificProduct,
  createProduct,
  deleteProduct,
  updateProduct,
  createOption,
  deleteOption,
  updateOption
}
